/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {useContext, useCallback, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import {ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useTranslator } from '@jutro/locale';
import '@xengage/gw-platform-translations';
import _ from 'lodash';
import classNames from 'classnames';
import appConfig from 'app-config';
import { MLNameDetailsComponent, MLInsuredCandidatesComponent } from 'ml-components-common-react';
import {MLDriverVehicleUtil} from "ml-portals-util-react";
import metadata from './WatercraftOperatorPopupComponent.metadata.json5';

function WatercraftOperatorPopupComponent(props) {
    const translator = useTranslator();

    const {
        id,
        onValidate,
        showValidationErrors,
        submissionVM,
        watercraftOperatorVM,
        onModelChange,
        onSave,
        showActionRow,
        isEdit
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const { getFilteredGender } = MLDriverVehicleUtil();

    const isAMP = appConfig.portalCode === 'AMP';

    const { refreshData } = useDataRefresh();

    const [showErrors, updateShowErrors] = useState(showValidationErrors);
    if(!_.isUndefined(watercraftOperatorVM.contact.isGenderRequired)) {
        watercraftOperatorVM.contact.isGenderRequired.value = true;
    };

    if(!_.isUndefined(watercraftOperatorVM.isRelationshipRequired)) {
        watercraftOperatorVM.isRelationshipRequired.value = true;
    };

    if(!_.isUndefined(watercraftOperatorVM.isYearsOfExperienceRequired)) {
        watercraftOperatorVM.isYearsOfExperienceRequired.value = true;
    };

    const [insuredCandidateSelected, setInsuredCandidateSelected] = useState(false);

    const mapAvailableValues = (values) => {
        return values.map((type) => {
            return {
                code: type.code,
                name: translator({
                    id: type.name,
                    defaultMessage: type.name
                })
            };
        });
    };

    useEffect(()=>{
        if(showValidationErrors){
            updateShowErrors(showValidationErrors)
        }
    },[showValidationErrors])

    const getAvailableRelationshipToInsuredValues = () => {
        return mapAvailableValues(watercraftOperatorVM.relationshipToInsured.aspects.availableValues);
    };

    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const syncExcludeWatercraftOperatorChange = (value) => {
        watercraftOperatorVM.isExcluded.value = value;
        onModelChange(watercraftOperatorVM);
    };

    const onSaveDetails = useCallback(() => {
        if (!(watercraftOperatorVM.aspects.valid && watercraftOperatorVM.aspects.subtreeValid)) {
            updateShowErrors(true);
            return false;
        }
        if (onSave) {
            return onSave(watercraftOperatorVM, isEdit);
        }
        return false;
    }, [watercraftOperatorVM, onSave, isEdit]);

    const onChangeDOB = (contact) => {
        if (contact.value.dateOfBirth) {
            contact.value.dateOfBirthForNonDriver = contact.value.dateOfBirth;
        }
    };

    const getInputStyle = useCallback(() => {
        return isAMP ? classNames('remove-form-group-spacing', 'col-md-6') : classNames('remove-form-group-spacing', 'col-md-4');
    }, [isAMP]);

    const resolvers = {
        resolveComponentMap: {
            mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
            mlnamedetailscomponent: MLNameDetailsComponent
        },
        resolveCallbackMap: {
            onSaveDetails: onSaveDetails
        }
    };

    const nbGenderState = _.get(submissionVM, 'baseData.isValidNonBinaryGenderState_Ext.value');

    const overrides = {
        insuredCandidatesComponent: {
            visible: !isEdit,
            submissionVM,
            watercraftOperatorVM,
            setInsuredCandidateSelected,
            onValueChange: refreshData,
            viewModelService,
            showValidationErrors : showErrors,
            initPublicID : watercraftOperatorVM?.value?.contact?.publicID,
            isNavigationChange: true
            
        },
        formFieldsContainer: {
            visible: insuredCandidateSelected || isEdit
        },
        nameDetailsComponent: {
            layout: isAMP ? 'ML-Split' : 'ML-Name-Default',
            showLabels: isAMP,
            personVM: watercraftOperatorVM.contact,
            // to identify as a Component for FormModalPopover to attach onValidate function
            isComponent: true,
            onModelChange,
            onValidate,
            showValidationErrors: showErrors
        },
        relationshipControl: {
            className: getInputStyle()
        },
        dobControl: {
            className: getInputStyle()
        },
        dob: {
            onBlur: () => { 
                onChangeDOB(watercraftOperatorVM.contact);
            },
            validationMessages: watercraftOperatorVM?.contact?.dateOfBirth?.aspects?.validationMessages
        },
        relationship: {
            availableValues: getAvailableRelationshipToInsuredValues(),
            validationMessages: watercraftOperatorVM?.relationshipToInsured?.aspects?.validationMessages
        },
        actionRow: {
            visible: showActionRow
        },
        genderRow: {
            path: "contact.gender",
            availableValues: getFilteredGender(nbGenderState)
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            model={watercraftOperatorVM}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
            onModelChange={onModelChange}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

WatercraftOperatorPopupComponent.propTypes = {
    id: PropTypes.string,
    onValidate: PropTypes.func,
    showValidationErrors: PropTypes.bool,
    watercraftOperatorVM: PropTypes.shape({}).isRequired,
    onModelChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    showActionRow: PropTypes.bool
};

WatercraftOperatorPopupComponent.defaultProps = {
    id: undefined,
    onValidate: undefined,
    showValidationErrors: undefined,
    showActionRow: true
};

export default WatercraftOperatorPopupComponent;
